import type { Resource } from '../../';
export const forms_error_notEmpty: Resource = {"default":"The {name} field is required."};
